module.exports = 'M 16, 16 m -12, 0 a 12,12 0 1,0 24,0 a 12,12 0 1,0 -24,0'



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Icon/paths/circle.js